var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn19(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.31,53.78H35a1.7,1.7,0,0,0-1.7,1.7v6.83A1.7,1.7,0,0,0,35,64H62.31a1.7,1.7,0,0,0,1.7-1.7V55.48A1.7,1.7,0,0,0,62.31,53.78Zm-1.7,6.83H36.7V57.18H60.61ZM37.67,39.07l-1.22,1.21a1.71,1.71,0,0,0,0,2.41l4.83,4.82a1.71,1.71,0,0,0,1.2.5,1.69,1.69,0,0,0,1.2-.5L58.17,33a1.7,1.7,0,0,0,0-2.4L53.34,25.8a1.7,1.7,0,0,0-2.4,0L49.72,27,37.64,14.93l1.22-1.21a1.71,1.71,0,0,0,0-2.4L34,6.49a1.7,1.7,0,0,0-2.4,0L17.14,21a1.71,1.71,0,0,0,0,2.41L22,28.2a1.7,1.7,0,0,0,1.2.5,1.68,1.68,0,0,0,1.2-.5L25.59,27,28,29.42,7.49,49.94a5.11,5.11,0,0,0,7.23,7.23L35.24,36.65Zm14.47-9.66,2.42,2.42L42.48,43.91l-2.42-2.43Zm-29-4.81-2.42-2.43L32.83,10.1l2.42,2.42Zm4.82,0,7.25-7.25L47.32,29.42l-7.25,7.25ZM12.32,54.76a1.71,1.71,0,0,1-2.43-2.42L30.41,31.82l2.43,2.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn19);
export default __webpack_public_path__ + "static/media/icn_19.f85054b45cfa10a59828c1faa0876013.svg";
export { ForwardRef as ReactComponent };